'use client';

import { BoxHeader } from '@bytel/trilogy-react';

export function BannerText({ bannerText }: Readonly<{ bannerText?: string }>) {
    if (!bannerText) {
        return null;
    }
    return <BoxHeader className='has-text-centered is-justified-center'>{bannerText}</BoxHeader>;
}
